import { ConfigOption } from '@ngx-formly/core';
import { FormlyFieldInput } from './input.type';

export function withFormlyInput(): ConfigOption {
  return {
    types: [
      {
        name: 'input',
        component: FormlyFieldInput,
        wrappers: ['form-field']
      }
    ]
  };
}